import { render, staticRenderFns } from "./CompletionModal.vue?vue&type=template&id=b3a18926&scoped=true&"
import script from "./CompletionModal.vue?vue&type=script&lang=js&"
export * from "./CompletionModal.vue?vue&type=script&lang=js&"
import style0 from "./CompletionModal.vue?vue&type=style&index=0&id=b3a18926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a18926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3a18926')) {
      api.createRecord('b3a18926', component.options)
    } else {
      api.reload('b3a18926', component.options)
    }
    module.hot.accept("./CompletionModal.vue?vue&type=template&id=b3a18926&scoped=true&", function () {
      api.rerender('b3a18926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/CompletionModal.vue"
export default component.exports